import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX } = FiIcons;

const Datenschutz = ({ onClose }) => {
  return (
    <div className="max-w-3xl relative">
      {onClose && (
        <button 
          onClick={onClose}
          className="mb-8 flex items-center text-azure-600 font-bold hover:text-azure-700 transition-colors"
        >
          <SafeIcon icon={FiX} className="mr-2" /> Fenster schließen
        </button>
      )}

      <h2 className="text-3xl font-bold text-black mb-8">Datenschutzerklärung</h2>
      <div className="space-y-8 text-gray-700 leading-relaxed">
        <section>
          <h3 className="text-xl font-bold text-black mb-4">1. Datenschutz auf einen Blick</h3>
          <p className="font-bold mb-2">Allgemeine Hinweise</p>
          <p className="mb-4">
            Die folgenden Hinweise geben einen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen oder über die angebotenen Funktionen mit uns in Kontakt treten. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
          </p>
          <p>
            Die Verarbeitung personenbezogener Daten erfolgt im Einklang mit den gesetzlichen Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO).
          </p>
        </section>
        <section className="border-t pt-8">
          <h3 className="text-xl font-bold text-black mb-4">2. Verantwortliche Stelle</h3>
          <p className="mb-1 font-bold text-black">Nadine Rau u. Mike Trepte GbR</p>
          <p>Bettenhäuserstraße 1</p>
          <p>34123 Kassel</p>
          <p>Deutschland</p>
          <p className="mt-4 text-black">
            E-Mail: <a href="mailto:mike.trepte@ki-kundenkommunikation.de" className="text-azure-600 underline">mike.trepte@ki-kundenkommunikation.de</a>
          </p>
          <p>Telefon: 0561 / 43027276</p>
        </section>
        <section className="border-t pt-8">
          <h3 className="text-xl font-bold text-black mb-4">3. Bereitstellung der Website und Hosting</h3>
          <p className="font-bold mb-2">Hosting über Netlify</p>
          <p className="mb-4">
            Diese Website wird technisch über Netlify, Inc., 2325 3rd Street, Suite 296, San Francisco, CA 94107, USA bereitgestellt.
          </p>
          <p className="mb-4">
            Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherem und stabilem Betrieb).
          </p>
        </section>
        <section className="border-t pt-8">
          <h3 className="text-xl font-bold text-black mb-4">10. Cookies und Tracking</h3>
          <p className="p-4 bg-azure-50 rounded-lg font-medium text-azure-700">
            Diese Website verwendet keine Cookies zu Analyse- oder Trackingzwecken. Es werden keine Nutzerprofile erstellt.
          </p>
        </section>
      </div>

      {onClose && (
        <button 
          onClick={onClose}
          className="mt-12 w-full py-4 bg-gray-100 text-gray-600 font-bold rounded-lg hover:bg-gray-200 transition-colors flex items-center justify-center"
        >
          <SafeIcon icon={FiX} className="mr-2" /> Fenster schließen
        </button>
      )}
    </div>
  );
};

export default Datenschutz;